import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AbilityServiceSignal } from '@casl/angular';
import { TranslatePipe } from '@ngx-translate/core';
import { RoleAction, RolePermissionSubject } from '@wilson/interfaces';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { TrainingQualificationCreateService } from '../training-qualifications-create-drawer/training-qualifications-create.service';

@Component({
  selector: 'wilson-training-qualification-create-trigger',
  standalone: true,
  imports: [NzButtonModule, NzTooltipModule, TranslatePipe],
  templateUrl: './training-qualification-create-trigger.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrainingQualificationCreateTriggerComponent {
  private readonly trainingQualificationCreateService = inject(
    TrainingQualificationCreateService,
  );

  public can = inject(AbilityServiceSignal).can;
  public readonly RoleAction = RoleAction;
  public readonly RolePermissionSubject = RolePermissionSubject;

  public showTrainingQualificationCreateDrawer(): void {
    this.trainingQualificationCreateService.setTrainingQualificationCreateDrawerVisible(
      true,
    );
  }
}
